import { Button } from '@repo/shadcn';
import { ColumnDef, Row } from '@tanstack/react-table';
import { useState } from 'react';
import { LuArrowUpDown } from 'react-icons/lu';

import { useUpdateRoleMutation } from '@/features/slice/users/roles.permission/role-permission-api-slice';

import { Permissions } from './permissions';

const RolePermissionCell = ({
    row,
}: {
    row: Row<{
        name: string[];
        id: string;
        description: string;
        permissions: any[];
    }>;
}) => {
    const [permissions, setPermissions] = useState(row.original.permissions);
    const [updateRolePermission] = useUpdateRoleMutation();

    const handlePermissionChange = (
        resourceName: string,
        permissionType: string,
        checked: boolean,
    ) => {
        const apiReq = {
            name: row.original.name,
            permissions: {
                [resourceName]: {
                    ...permissions[resourceName as any],
                    [permissionType]: checked,
                },
            },
        };
        updateRolePermission({
            id: row.original.id,
            data: apiReq,
        });

        setPermissions((prevPermissions) => ({
            ...prevPermissions,
            [resourceName]: {
                ...prevPermissions[resourceName as any],
                [permissionType]: checked,
            },
        }));
    };
    return (
        <div>
            {Object.entries(permissions)
                .sort()
                .map(([resourceName, resourcePermissions]) => (
                    <Permissions
                        key={resourceName}
                        resourceName={resourceName}
                        permissions={resourcePermissions}
                        onPermissionChange={handlePermissionChange}
                    />
                ))}
        </div>
    );
};

export const columns: ColumnDef<{
    name: string[];
    id: string;
    description: string;
    permissions: any[];
}>[] = [
    {
        accessorKey: 'name',
        header: ({ column }) => {
            return (
                <Button
                    variant="ghost"
                    onClick={() =>
                        column.toggleSorting(column.getIsSorted() === 'asc')
                    }
                >
                    Role Name
                    <LuArrowUpDown className="ml-2 h-4 w-4" />
                </Button>
            );
        },
        cell: ({ row }) => (
            <div className="font-medium">{row.getValue('name')}</div>
        ),
    },

    {
        accessorKey: 'permissions',
        header: () => <div>Permissions Access</div>,
        cell: RolePermissionCell,
    },

    // {
    //   accessorKey: 'permission',
    //   header: () => <div>Permission</div>,
    //   cell: ({ row }) => {
    //     return row.original.permission.map((permission: string) => {
    //       return <Badge variant="outline"> {permission}</Badge>;
    //     });
    //   },
    // },
    {
        accessorKey: 'action',
        header: () => <div>Action</div>,
    },
];
